import { Text, SkeletonLoader, ErrorBadgeIcon } from '@frontend/design-system';
import { SKELETON_CONFIG } from './constants';
import { errorStyles, skeletonContainerStyles, summaryTextStyles } from './styles';

type SummaryContentProps = {
  isError: boolean;
  errorMessage: string;
  isLoading: boolean;
  summaryText: string;
};

export const SummaryContent = ({ isError, errorMessage, isLoading, summaryText }: SummaryContentProps) => {
  if (isError) {
    return (
      <div css={errorStyles}>
        <ErrorBadgeIcon color='error' />
        <Text size='medium' color='error'>
          {errorMessage}
        </Text>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div css={skeletonContainerStyles}>
        {SKELETON_CONFIG.WIDTHS.map((width, index) => (
          <SkeletonLoader key={index} width={width} height={16} shape='rectangle' />
        ))}
      </div>
    );
  }

  return (
    <Text size='small' css={summaryTextStyles}>
      {summaryText}
    </Text>
  );
};
